enum ROUTES {
  DEFAULT = 'default',
  LOGIN = 'login',
  ERROR = 'error',
  WILDCARD = 'wildcard',
  INSCRIPTION_ETUDIANT = 'inscription-etudiant',
  INSCRIPTION_ETUDIANT_APERCU = 'inscription-etudiant-apercu',
  INSCRIPTION_ETUDIANT_FORMULAIRE = 'inscription-etudiant-formulaire',
  FICHE_REPONDANT_GESTION = 'fiche-repondant-list',
  FICHE_REPONDANT_OVERVIEW = 'fiche-repondant-overview',
  FICHE_REPONDANT_CREATE = 'fiche-repondant-create',
  FICHE_REPONDANT_UPDATE = 'fiche-repondant-update'
}

export default ROUTES